import { render } from "./popover.vue?vue&type=template&id=3ad12dbc"
import script from "./popover.vue?vue&type=script&lang=js"
export * from "./popover.vue?vue&type=script&lang=js"

import "./popover.vue?vue&type=style&index=0&id=3ad12dbc&lang=scss"

import exportComponent from "/home/node/ks-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__